import { Button, Form, Input, Modal, Table } from "antd";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #fff;
`;

export const HeaderContent = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 15px;
  justify-content: space-between;
  align-items: center;
  gap: 25px;
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const NewReasonButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: rgba(0, 34, 68, 1);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: fit-content;
  height: 38px;
  white-space: nowrap;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  line-height: 25px;
  color: #ffffff;
  font-family: "Open Sans";
  transition: background-color 0.3s;
  padding: 0 16px;

  &:hover {
    background-color: rgba(0, 34, 68, 0.8);
  }
`;

export const ActionsCell = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 8px;
`;

export const ActionButton = styled(Button)`
  min-width: 126px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none !important;
  border-radius: 5px;

  font-size: 12px;
  font-weight: 700;
  font-family: "Inter";

  text-transform: uppercase;

  background-color: ${({ danger }) =>
    danger ? "rgba(254, 202, 202, 1)" : "rgba(226, 232, 240, 1)"} !important;

  color: ${({ danger }) =>
    danger ? "rgba(153, 27, 27, 1)" : "rgba(0, 34, 68, 1)"} !important;

  box-shadow: none !important;
  transition: transform 0.15s ease !important;

  &:hover,
  &:focus,
  &:active,
  &:not(:disabled):hover,
  &:not(:disabled):focus,
  &:not(:disabled):active {
    background-color: ${({ danger }) =>
      danger ? "rgba(254, 202, 202, 1)" : "rgba(226, 232, 240, 1)"} !important;

    color: ${({ danger }) =>
      danger ? "rgba(153, 27, 27, 1)" : "rgba(0, 34, 68, 1)"} !important;

    border: none !important;
    box-shadow: none !important;
  }
  svg {
    font-size: 16px;
    stroke-width: 100;
  }
  &:hover,
  &:focus {
    transform: scale(0.95);
  }

  &:active {
    transform: scale(0.97);
  }
`;

export const CustomSearch = styled(Input)`
  width: 100% !important;

  height: 38px !important;
  border-radius: 5px !important;

  .ant-input {
    border-radius: 5px !important;
  }
`;
